module.exports = __webpack_public_path__ + "img/2w_tassei.cea0148c.png";